import { useDispatch } from "react-redux";
import { ReactNode, useCallback, useMemo } from "react";

import { Dispatch } from "@/utils/store";

export interface Alerts {
  success: (title: string, text?: ReactNode) => void;
  error: (title?: string, text?: string) => void;
  confirm: (title: string, text?: string) => Promise<boolean>;
}

const useAlerts = () => {
  const dispatch = useDispatch<Dispatch>();

  const success = useCallback(
    (title: string, text?: ReactNode) =>
      dispatch.alerts.show({ title, text, icon: "success" }),
    [dispatch]
  );

  const error = useCallback(
    (title?: string, text?: string) =>
      dispatch.alerts.show({
        title: title || "Ooops. An error occurred!",
        text,
        icon: "error",
      }),
    [dispatch]
  );

  const confirm = useCallback(
    (title: string, text?: string) => dispatch.alerts.confirm({ title, text }),
    [dispatch]
  );

  const close = useCallback(() => dispatch.alerts.close(), [dispatch]);

  const alerts = useMemo(
    () => ({
      success,
      error,
      confirm,
      close,
    }),
    [success, confirm, error, close]
  );

  return alerts;
};

export default useAlerts;
